import clsApi from '@cls/clsApi'
import clsApiPost from '@cls/clsApiPost'


class clsResourcePlanningApi extends clsApiPost {

    /**
     * Load employees available for planning
     */
    async loadResources(date) {
        return this.post(`loadresources`, {date: date ||null}); 
    }

    /**
     * Load planning for a week 
     */
    async loadWeekPlanning(year, week) {
        return this.post(`loadweekplanning`, {year: year, week: week}); 
    }

    /**
     * Save the from time for an appointment
     */
    async setAppointmentFrom(id_appointment, from) {
        return this.post('appointment/setfrom', {id: id_appointment, from: from}); 
    }
    /**
     * Save the to time for an appointment
     */
    async setAppointmentTo(id_appointment, to) {
        return this.post('appointment/setto', {id: id_appointment, to: to}); 
    }
    /**
     * Set the given appointment visible for the employee or set all employee appointments for the given day visible.
     * Note that this is only applicable for workorder appointments.
     * @param {*} id_appointment 
     * @returns 
     */
    async setAppointmentVisible(id_appointment, dt) {
        return this.post('appointment/workorder/setvisible', {id: id_appointment || null, date: dt||null}); 
    }
    /**
     * Set the given appointment hidden for the employee or set all employee appointments for the given day hidden.
     * Note that this is only applicable for workorder appointments.
     * @param {*} id_appointment 
     * @returns 
     */
    async setAppointmentHidden(id_appointment, dt) {
        return this.post('appointment/workorder/sethidden', {id: id_appointment || null, date: dt||null}); 
    }

    /**
     * Update the adjustable properties of an appointment.
     * @param {*} appointment 
     * @returns 
     */
    async updateAppointment(appointment) {
        return this.post('appointment/update', appointment); 
    }
    /**
     * Remove an appointment. 
     * @param {*} appointment 
     * @returns 
     */
    async removeAppointment(appointment) {
        var id_appointment = appointment.id || appointment;
        return this.post('appointment/remove', {id: id_appointment}); 
    }
    /**
     * insert an appointment specific for a workorder.
     * @param {*} appointment 
     * @returns 
     */
    async insertAppointmentWorkorder(appointment) {
        return this.post('appointment/workorder/create', appointment); 
    }
    /**
     * insert an appointment specific for absence.
     * @param {*} appointment 
     * @returns 
     */
    async insertAppointmentAbsence(appointment) {
        return this.post('appointment/abcence/create', appointment); 
    }

    
    /**
     * Load unassigned workorders. Workorders without appointments.
     * @param {} year 
     * @param {*} week 
     * @param {*} filter 
     * @returns 
     */
    async loadWorkorders(year, week, filter) {
        return this.post('workorders/load/plannable', {year: year, week: week, filter: filter}); 
    }

    /**
     * refresh the workorder with the given id. Load the data as it is usable on the planboard. 
     * Not to be confused with the workorder data as loaded in a dialog.
     * @param {*} id_workorder 
     * @returns 
     */
    async refreshWorkorder(id_workorder) {
        return this.post('workorders/refresh', {id: id_workorder}); 
    }

    sendEmployee(model) { 
        return this.post(`appointment/sendemployee`, model); 
    }
    loadEmployeeSendData(id_appointment) { 
        return this.post(`appointment/loademployeesenddata`, {id: id_appointment}); 
    }

    async moveEmployeeTop(id) {
        return this.post(`employees/setordertop`, {id_employee: id}); 
    }
    async moveEmployeeBottom(id) {
        return this.post(`employees/setorderbottom`, {id_employee: id}); 
    }
    async swapEmployeeOrder(id1, id2) {
        return this.post(`employees/swaporder`, {id_employee1: id1, id_employee2: id2}); 
    }


}
export default clsResourcePlanningApi;
